import parse from "html-react-parser";
import { useMediaQuery } from "react-responsive";

const ImageSectionItem = (props) => {

    const { imageURL, imageURLMobile, title, textArray, layout, imagePosition, isBigImage, isAnimatedImage, modern, imageClassName } = props // layout > row y column; side > before y after

    const isMobile = useMediaQuery({ maxWidth: 1280 })
    const baseImageClass = (isBigImage && isAnimatedImage) ? "big-image animated-image" : (isBigImage) ? "big-image" : (isAnimatedImage) ? "animated-image" : "square-image"
    const finalImageClass = imageClassName ? `${baseImageClass} ${imageClassName}` : baseImageClass

    if (isMobile)
        return (
            <section className="flex w100 white-bkg">
                <section className="main-middle-section-mobile">

                    {
                        (imagePosition === "before") ? <img loading="lazy" alt="Imagen" src={imageURLMobile || imageURL} className={finalImageClass}></img> : <></>
                    }

                    <section className="main-middle-subsection-mobile">
                        <h2 className="middle-section-title">{title}</h2>
                        {
                            (textArray?.map((t,index) => {
                                return (<article key={index}>{parse(t)}</article>)
                            }))
                        }
                    </section>

                    {
                        (imagePosition === "after") ? <img loading="lazy" alt="Imagen" src={imageURLMobile || imageURL} className={finalImageClass}></img> : <></>
                    }
                </section>
            </section>
        )
    else
        return (
            <section className="flex w100 white-bkg">
                <section className={`${(layout === "column") ? "flex col acenter jcenter pad-30 main-middle-section-2 " : "flex  acenter jcenter pad-30 main-middle-section-2"}${modern ? " modern-content-row" : ""}`}>

                    {
                        (imagePosition === "before") ? <img loading="lazy" alt="Imagen" src={imageURL} className={finalImageClass}></img> : <></>
                    }

                    <section className={`main-middle-subsection-2 w100${modern ? " modern-content-card" : ""}`}>
                        <h2 className="middle-section-title">{title}</h2>
                        {
                            (textArray?.map((t,index) => {
                                return (<article key={index}>{parse(t)}</article>)
                            }))
                        }
                    </section>

                    {
                        (imagePosition === "after") ? <img loading="lazy" alt="Imagen" src={imageURL} className={finalImageClass}></img> : <></>
                    }
                </section>
            </section>
        )



}

export default ImageSectionItem